import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export default function Forbidden() {
  const { t } = useLanguage();

  useEffect(() => {
    document.title = `403 - ${t('accessDenied')} - NNC Revision Ltd.`;
  }, [t]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-4 text-center bg-slate-50">
      <div className="max-w-md bg-white p-8 md:p-10 rounded-lg shadow-sm border border-slate-200">
        <span className="text-6xl font-serif font-bold text-rose-600 block mb-4">403</span>
        <h1 className="text-2xl sm:text-3xl font-serif font-bold text-brand-navy mb-4">
          {t('accessDenied')}
        </h1>
        <p className="text-slate-600 mb-8 text-sm leading-relaxed">
          {t('accessDeniedDesc')}
        </p>
        <Link
          to="/"
          className="inline-block bg-brand-gold hover:bg-brand-gold-hover text-white font-semibold py-2.5 px-6 rounded text-xs sm:text-sm transition-colors cursor-pointer uppercase tracking-wider"
        >
          {t('goToHome')}
        </Link>
      </div>
    </div>
  );
}
